import Ajax from '../js/common/ajax';
import Qs from "qs";

export default {
    //导出订单
    mallOrder(params) {
		  return Ajax.getExport("/export/mallOrder", params)
    },
    //销售汇总表（合伙人）
    summaryPartner(params) {
		  return Ajax.getExport("/export/summary1", params)
    },
    //销售汇总表（社区）
    summaryCommunity(params) {
		  return Ajax.getExport("/export/summary2", params)
    },

    //销售数据（社区）
    summaryDataCommunity(params) {
      return Ajax.getExport("/export/summaryCommunity", params)
    },
    
    //销售数据（部门）
    summaryDataGroup(params) {
      return Ajax.getExport("/export/summaryGroup", params)
    },
    //销售数据（人员）
    summaryDataPerson(params) {
      return Ajax.getExport("/export/summaryPerson", params)
    },

    //员工列表
    person(params) {
      return Ajax.getExport("/export/person", params)
    },

     //日记账模板
     cashDailyTemplate() {
      return Ajax.getExport("/export/getCashDailyTemplate",{})
    },
      //日记账模板导入
      cashDailyImport(params) {
        return Ajax.post("/export/importCashDaily",params,{ 'Content-Type': 'multipart/form-data' })
      },
         
}

